// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"82666284","274":"e5a956ef"}[chunkId] + ".chunk.js";
};